"use client";

import { CloudSun, MapPin } from "lucide-react";

export const WeatherWidget = () => {
  return (
    <div className="w-full h-full bg-gradient-to-br from-[#1E5799] to-[#2989D8] rounded-[1.5rem] p-4 text-white flex flex-col justify-between shadow-lg relative overflow-hidden group hover:scale-[1.02] transition-transform">
      <div className="absolute top-0 right-0 p-3 opacity-20">
         <CloudSun className="w-24 h-24" />
      </div>
      
      <div className="relative z-10">
        <div className="flex items-center gap-1 text-xs font-medium opacity-90 mb-1">
           <MapPin className="w-3 h-3" />
           <span>Delhi</span>
        </div>
        <div className="text-4xl font-light tracking-tighter">28°</div>
      </div>

      <div className="relative z-10 space-y-1">
         <div className="text-xs font-medium">Mostly Sunny</div>
         <div className="text-[10px] opacity-80 flex justify-between">
            <span>H:31°</span>
            <span>L:18°</span>
         </div>
      </div>
    </div>
  );
};
